/* globals console, google, module, navigator, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    Contacts = require('../collections/contacts'),
    // Create = require('./create'),
    user = require('../models/user'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'dashboard-sidebar-menu'
    },
    tagName: 'div',
    template: templates.dashboardSidebarMenu,
    templateContext: function () {
        return {
            hasAdminAccess: user.hasCapability('administrator'),
            hasOrganizationAccess: user.hasCapability('organization')
        };
    },
    initialize: function () {
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.render();
        }, this));
    },
    selected: function (panel) {
        window.location.hash = '#' + panel;
        this.$el.find('a').each(function (index, a) {
            jQuery(a).toggleClass('disabled selected', a.href.indexOf(panel) !== -1);
        });
    }
});
